"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ChunkData_chunk;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkData = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class ChunkData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    constructor(chunk) {
        super(chunk.id);
        _ChunkData_chunk.set(this, void 0);
        __classPrivateFieldSet(this, _ChunkData_chunk, chunk, "f");
    }
    get id() {
        return __classPrivateFieldGet(this, _ChunkData_chunk, "f").id;
    }
    get name() {
        return __classPrivateFieldGet(this, _ChunkData_chunk, "f").name;
    }
    get typeHint() {
        return __classPrivateFieldGet(this, _ChunkData_chunk, "f").typeHint;
    }
    get tooltip() {
        return __classPrivateFieldGet(this, _ChunkData_chunk, "f").tooltip;
    }
    get displayname() {
        return __classPrivateFieldGet(this, _ChunkData_chunk, "f").displayname;
    }
    get hidden() {
        return __classPrivateFieldGet(this, _ChunkData_chunk, "f").hidden;
    }
    clone() {
        return new ChunkData(__classPrivateFieldGet(this, _ChunkData_chunk, "f"));
    }
}
exports.ChunkData = ChunkData;
_ChunkData_chunk = new WeakMap();
//# sourceMappingURL=ChunkData.js.map